import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import EditableTextView from "../../../components/EditableTextView";
import Utils from "../../../utils";

function ModuleView(props) {
  const [module, setModule] = props.moduleHooks;
  const [topic, setTopic] = props.topicHooks;
  return (
    <div className="h-full">
      <h1 className="font-extrabold text-lg my-3 text-center">Module View</h1>

      <div className="m-2">
        <TextField
          label="Module Name"
          variant="filled"
          size="small"
          value={module.name ?? ""}
          onChange={(e) => {
            setModule({ ...module, name: e.target.value });
          }}
          // error={
          //   getIn(formik.touched, "courseDetails.curriculum") &&
          //   Boolean(getIn(formik.errors, "courseDetails.curriculum"))
          // }
          // helperText={
          //   getIn(formik.touched, "courseDetails.curriculum") &&
          //   getIn(formik.errors, "courseDetails.curriculum")
          // }
          required
          fullWidth
        />
      </div>

      <div className="m-2">
        <TextField
          label="Module Description"
          variant="filled"
          size="small"
          value={module.description ?? ""}
          onChange={(e) =>
            setModule({ ...module, description: e.target.value })
          }
          required
          fullWidth
          multiline
        />
      </div>

      <div className="p-2">
        <div className="font-bold">Topics:</div>
        <div className="flex flex-col my-3 gap-3">
          {module.topics.map((t, index) => {
            if (t._deleted) {
              return;
            }
            var style = "p-2 rounded-lg cursor-pointer flex gap-2 items-center";
            if (topic) {
              if (topic._id == t._id) {
                style += " bg-secondaryDark ";
              } else {
                style += " bg-secondary  hover:bg-secondaryDark ";
              }
            } else {
              style += " bg-secondary  hover:bg-secondaryDark ";
            }

            return (
              <div
                key={index}
                className={style}
                onClick={() => {
                  setTopic(t);
                }}
              >
                <div className="flex-grow">{t.name}</div>
                <div
                  onClick={() => {
                    const temp = { ...module };
                    if (!t._new) {
                      t._deleted = true; // soft delete
                    } else {
                      temp.topics.splice(index, 1);
                    }

                    setModule(temp);
                  }}
                >
                  <MdDelete size={20} className="opacity-80 active:scale-110" />
                </div>
              </div>
            );
          })}
          <div
            className=" p-2 rounded-lg bg-primary cursor-pointer text-center text-white font-bold"
            onClick={() => {
              const newTopic = {
                name: "New Topic",
                _id: "LOCAL_" + Utils.uniqueId(),
                _new: true, // imp: it is send to server to notify this is newly created and create this object
              };
              const temp = { ...module };
              temp.topics.push(newTopic);
              setModule(temp);
              setTopic(newTopic);
            }}
          >
            New Topic +
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModuleView;
